<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_146_3127)">
      <path
        d="M33.7691 15.3041L33.7494 15.5177L33.8906 15.6792L37.6694 20L33.8906 24.3208L33.7494 24.4823L33.7691 24.6959L34.2956 30.4095L28.7062 31.6791L28.4965 31.7267L28.3868 31.9118L25.4607 36.8506L20.1976 34.5906L19.9997 34.5056L19.8019 34.5911L14.5394 36.8663L11.6138 31.9285L11.5042 31.7434L11.2944 31.6958L5.70499 30.4261L6.23156 24.6958L6.25118 24.4822L6.11003 24.3208L2.33071 19.9994L6.11061 15.6618L6.25113 15.5006L6.23156 15.2876L5.70509 9.55836L11.2931 8.30454L11.5038 8.25727L11.6138 8.07153L14.5399 3.13273L19.803 5.39277L20.0003 5.47748L20.1976 5.39277L25.4601 3.13297L28.3865 8.08761L28.4961 8.27317L28.7062 8.32091L34.2956 9.59051L33.7691 15.3041Z"
        fill="#1A1A1A"
        stroke="#3B3B3B" />
      <mask
        id="mask0_146_3127"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="9"
        y="10"
        width="23"
        height="22">
        <rect x="9.00098" y="10" width="22" height="22" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_146_3127)">
        <path
          d="M19.2449 30.1673C19.0158 30.1673 18.7866 30.1215 18.5574 30.0298C18.3283 29.9382 18.122 29.8007 17.9387 29.6173L11.3845 23.0632C11.2012 22.8798 11.0675 22.6774 10.9835 22.4559C10.8994 22.2343 10.8574 22.009 10.8574 21.7798C10.8574 21.5507 10.8994 21.3215 10.9835 21.0923C11.0675 20.8632 11.2012 20.6569 11.3845 20.4736L19.4512 12.384C19.6192 12.2159 19.8178 12.0822 20.047 11.9829C20.2762 11.8836 20.513 11.834 20.7574 11.834H27.3345C27.8387 11.834 28.2703 12.0135 28.6293 12.3725C28.9883 12.7316 29.1678 13.1632 29.1678 13.6673V20.2444C29.1678 20.4888 29.122 20.7218 29.0303 20.9434C28.9387 21.1649 28.8088 21.3597 28.6408 21.5277L20.5512 29.6173C20.3678 29.8007 20.1616 29.9382 19.9324 30.0298C19.7033 30.1215 19.4741 30.1673 19.2449 30.1673ZM25.0428 17.334C25.4248 17.334 25.7494 17.2003 26.0168 16.9329C26.2842 16.6656 26.4178 16.3409 26.4178 15.959C26.4178 15.577 26.2842 15.2524 26.0168 14.985C25.7494 14.7177 25.4248 14.584 25.0428 14.584C24.6609 14.584 24.3362 14.7177 24.0689 14.985C23.8015 15.2524 23.6678 15.577 23.6678 15.959C23.6678 16.3409 23.8015 16.6656 24.0689 16.9329C24.3362 17.2003 24.6609 17.334 25.0428 17.334Z"
          fill="white" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_146_3127">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
